import { useState } from "react";

const useStateTermAccept = () => {
    const [acceptTerms, setAcceptTerms] = useState(true);
    const [showError, setShowError] = useState(false);

    return {
        acceptTerms, setAcceptTerms,
        showError, setShowError,
    }
}

export default useStateTermAccept;